module.exports = __webpack_public_path__ + "static/media/complimentaryProductLogos.9df3b62b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/complimentaryProductLogos.png
// module id = 993
// module chunks = 0